export default (params) => ({
  trigger: {
    name: 'product_type_section.select_charger_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
